import React, {useState,useEffect} from 'react'
import Categories from './Categories'
import { Link } from 'react-router-dom';
import Footer from './Footer';

const WhatWeAreDoing = () => {

  const getShortLocation = (location) => {
            if (!location) return '';

            if (location.length <= 20) return location;

            const breakpoint = location.slice(20).search(/[ ,\.]/); // find first space, comma or period after 20
            if (breakpoint === -1) return location.slice(0, 20) + '...'; // no match, hard cut

            const cutIndex = 20 + breakpoint;
            return location.slice(0, cutIndex) + '...';
            };
            
    const categoriesData = [
  { title: "Primary Health", icon: "flaticon-tour", link:"/cvp/phg/primary-health",count: 5 },
  { title: "AgriTech", icon: "flaticon-cms", count: 2 },
  { title: "Freelance Tasks", icon: "flaticon-report", count: 2 },

]

    const chunkArray = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (_, index) =>
    arr.slice(index * size, index * size + size)
  );
};

let [opportunities, setopportunities] = useState([])

    useEffect(()=>{
          getopportunities()
        }, [])

let getopportunities = async()=>{
        // let fetchUrl = 'http://127.0.0.1:8000/get-community-venture-portfolio-opportunities'
        let fetchUrl = 'https://backend.jobflowonline.com/get-community-venture-portfolio-opportunities'
        let response = await fetch(fetchUrl, {
        method:'GET',
        headers:{
          'Content-Type':'application/json',
        //   'Authorization': 'Bearer ' + String(authTokens.access)
        }
      })
      let data = await response.json()
      if(response.status === 200){
        setopportunities(data)
      }else{
        alert('There is something wrong')
      }
      // setopportunities(data)
    }
  return (
    <>
    <div class="support-company-area fix section-padding2">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6 col-lg-6">
                        <div class="right-caption">
                            {/* <!-- Section Tittle --> */}
                            <div class="section-tittle section-tittle2">
                                <span>What we are doing</span>
                                <h2>Connecting Local Talent with Real Opportunities</h2>
                            </div>
                            <div class="support-caption">
                                <p class="pera-top">We want to give you the opportunity to make money and make impact outside your typical employment.
Whether you're a student, a skilled graduate, a stay-at-home parent, or someone in between jobs, our platform connects you to meaningful, flexible opportunities right within your community.</p>
                                <p>Through partnerships with local organizations, we offer real positions — from monitoring and evaluation roles, to digital design tasks, to public health outreach. These aren't just gigs — they're stepping stones to purpose-driven careers that create real value in society while putting money in your pocket.
                                    NB: These are not fulltime jobs, but rather part-time or project-based opportunities that allow you to earn while making a difference.
                                </p>
                                <b>We welcome Personnels from all fields.</b>
                                
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xl-6 col-lg-6">
                        <div class="support-location-img">
                            <img src={require("../assets/img/service/myImage.png")} alt="" />
                            {/* <img src={require("../assets/img/testmonial/testimonial-founder.png")} alt="" /> */}

                            <div class="support-img-cap text-center">
                                <p>Open Positions:</p>
                                <span>1,205</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
                    {/* <a href="about.html" class="btn w-100 post-btn">Post a job</a> */}
        {/* <Categories/> */}



        {/* <!-- Featured_job_start --> */}
        <section style={{backgroundColor:'rgb(242, 243, 246)'}} className="featured-job-area feature-padding">
            <div className="container">
                {/* <!-- Section Tittle --> */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-tittle text-center">
                            <span>Recent Ads</span>
                            <h2>Featured Listings</h2>
                        </div>
                    </div>
                </div>
                {chunkArray(opportunities, 2).map((row, i) => (
  <div className="row justify-content-center" key={i}>
    {row.map(item => (
      <div className="col-xl-6" key={item.id}>
        <div className="single-job-items mb-30">
          <div className="job-items">
            <div className="company-img">
              <Link to={`/opportunity-details/${item.id}/${item.title}`}>
                <img
                  style={{ maxWidth: '100px', maxHeight: '200px' }}
                  src={item.icon}
                  alt=""
                />
              </Link>
            </div>
            <div className="job-tittle">
              <Link to={`/opportunity-details/${item.id}/${item.title}`}>
                <h4>{item.title}</h4>
              </Link>
              <ul>
                <li style={{ marginRight: '5px' }}>{item.firm}</li>
                <li>
                  <i className="fas fa-map-marker-alt"></i> {getShortLocation(item.location)}
                </li>
                <li style={{ marginLeft: '10px' }} className="text-success">{item.remuneration}</li>
              </ul>
            </div>
          </div>
          <div className="items-link f-right">
            <Link to={`/opportunity-details/${item.id}/${item.title}`}>
              {item.modality}
            </Link>
            <span>{item.posted_ago}</span>
          </div>
        </div>
      </div>
    ))}
  </div>
))}

            </div>
            {/* <Button buttonLabel='More'/> */}
        </section>
        {/* <!-- Featured_job_end --> */}

        
        

        <Categories categories={categoriesData.slice(0, 3)} />
        </div>
        <Footer/>
    </>
  )
}

export default WhatWeAreDoing